













import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import ProcessedUpload from '@/Types/ProcessedUpload';

@Component({})
export default class WrappedUploadInput extends Vue {
    static COMPONENT_NAME = 'wrapped-upload-input'

    @Prop({type: Boolean, default: true}) multiple!: boolean
    @Prop({type: String, default: 'live'}) uploadBehavior!: 'live' | 'delayed'

    handleComplete(response: any): void {
        const { file: { name, url } }: { file: ProcessedUpload } = response;

        this.$emit('uploadFile', {
                fieldName: this.$attrs.name,
                file: {
                    name,
                    url
                }
            },
        );
    }

    handleRemoved(files: { path: { url: string } }[]): void {
        this.$emit('removeFile', {
                fieldName: this.$attrs.name,
                remaining: files.map(file => file.path.url),
            },
        );
    }
}
